// socket.js
import { io } from 'socket.io-client';

let socket = null;

/**
 * Connects the socket with the provided userId (used to join the user-specific room).
 * @param {string|number} userId - The authenticated user ID.
 * @returns {socket} - The connected socket instance.
 */
export function connectSocket(userId) {
	// If socket already exists and is connected, no need to reconnect
	if (socket?.connected) return socket;

	// Create socket instance if not already created
	if (!socket) {
		socket = io(process.env.REACT_APP_API_URL, {
			autoConnect: false,
			transports: ['websocket'], // optional: forces WebSocket only
		});
	}

	// Set userId query and connect
	socket.io.opts.query = { userId: String(userId) };
	socket.connect();

	socket.on('connect', () => {
		console.log('[Socket] Connected:', socket.id, 'User:', userId);
	});

	socket.on('disconnect', (reason) => {
		console.warn('[Socket] Disconnected:', reason);
	});

	return socket;
}

/**
 * Returns the current socket instance, or null if not yet connected.
 * @returns {socket|null}
 */
export function getSocket() {
	return socket;
}

/**
 * Disconnects and clears the socket instance.
 * Call on logout or account switch.
 */
export function disconnectSocket() {
	if (socket) {
		socket.disconnect();
		socket = null;
		console.log('[Socket] Disconnected and reset');
	}
}
